import React, { useEffect, useMemo } from "react";
import { Button, Card, Col, Container, Row, Table } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import trialImg from "../../assets/img/trial.png";
import dashboardIcon from "../../assets/img/sidebar/svg/dashboard.svg";
import dealsIcon from "../../assets/img/sidebar/svg/deals.svg";
import crmIcon from "../../assets/img/sidebar/crm_2.png";
import calculatorIcon from "../../assets/img/sidebar/svg/calculator.svg";
import proposalIcon from "../../assets/img/sidebar/svg/proposal.svg";
import projectsIcon from "../../assets/img/sidebar/svg/projects.svg";
import { usePostHog } from "posthog-js/react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPageFavorites,
  fetchPageView,
  getManageUserBilling,
  getUserDetail,
} from "../../store/actions/users/users.actions";
import { faArrowRight, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { formatDate } from "../../utils/helpers/helper";
import { Pages } from "./data/Pages";
import { priceMap } from "../../data/apps";
import LabelSummary from "../../components/LabelSummary";

// New cardData with only the 7 specific services
let cardData = [
  {
    id: "dashboard",
    title: "Dashboard",
    description: "Overview of your projects and activities",
    imgSrc: dashboardIcon,
    linkTo: "/dashboard",
  },
  {
    id: "pipeline",
    title: "Pipeline",
    description: "Manage your sales pipeline and deals",
    imgSrc: dealsIcon,
    linkTo: "/myganarpro/favorites",
  },
  // {
  //   id: "itb_import",
  //   title: "ITB Importer",
  //   description: "Automatically import Invitation to Bid emails from your Gmail inbox and convert them to deals",
  //   imgSrc: itbImportIcon,
  //   linkTo: "/itb-import",
  // },
  {
    id: "contact",
    title: "Contact",
    description: "Manage your contacts and outreach",
    imgSrc: crmIcon,
    linkTo: "/crm",
  },
  {
    id: "cleanup_calculator_overview",
    title: "Cleaning Calculator",
    description: "Calculate bid amounts and analyze costs",
    imgSrc: calculatorIcon,
    linkTo: "/cleanup_calculator_overview",
  },
  {
    id: "proposal",
    title: "Proposal",
    description: "Create professional proposals with templates",
    imgSrc: proposalIcon,
    linkTo: "/proposal",
  },
  {
    id: "project_board",
    title: "Project Board",
    description: "Map-based project location and data",
    imgSrc: projectsIcon,
    linkTo: "/project_board",
  },
  {
    id: "project_research",
    title: "Project Research",
    description: "Research construction projects by location",
    imgSrc: projectsIcon,
    linkTo: "/project_research",
  },
];


const Home = () => {
  const { user } = useSelector((state) => state.auth);
  const userDetails = useSelector((state) => state.userDetails);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, user: profile } = userDetails;
  const { pageList } = useSelector((state) => state.listPageView);
  const { favorites } = useSelector((state) => state.ListFavoritePages);
  const uniqueFavorites = useMemo(()=> [...new Map(favorites.filter(item => item.page_url !== "deal/marketplace").map(item => [Pages[item.page_name]?.name, item])).values()], [favorites])
  const posthog = usePostHog();

  let [searchParams] = useSearchParams();
  const params_app = searchParams.get("app");

  useEffect(() => {
    dispatch(fetchPageView());
  }, [dispatch]);

  useEffect(() => {
    if (user && !loading) {
      posthog?.identify(`${user.id}-${user.email}`, {
        email: user.email,
        name: `${user.first_name} ${user.last_name}`,
      });
      let data =
        localStorage[
          "ph_" + process.env.REACT_APP_PUBLIC_POSTHOG_KEY + "_posthog"
        ];
      if (data) {
        data = JSON.parse(data);
        posthog.alias(data["distinct_id"], `${user.id}-${user.email}`);
      }
    }
  }, [user, loading, posthog]);

  useEffect(() => {
    if (profile?.is_cleaning_company) {
      dispatch(getUserDetail());
    }
  }, [dispatch, profile?.is_cleaning_company]);

  useEffect(()=> {
    // Handle app switching logic if needed
    let ganarpro_app = localStorage.getItem(`ganarpro_app${user?.id}`);
    const price_id = profile?.subscriptions[0]?.metadata.price_id;
    const app = priceMap[price_id] || "cleaning";
    if (app !== ganarpro_app && ganarpro_app !== "deal") {
      localStorage.setItem(`ganarpro_app${user?.id}`, app);
      ganarpro_app = app
    }

    if (params_app) {
      ganarpro_app = localStorage.setItem(`ganarpro_app${user?.id}`, params_app);
      localStorage.setItem(`isSwitchButton_${user?.id}`, `${params_app==="cleaning"?"false":"true"}`);
      navigate("/")
    }

  }, [dispatch, profile])

  useEffect(() => {
    dispatch(fetchPageFavorites());
  }, [dispatch, user?.id]);

  return (
    <Container>
      <Row className="mt-3 justify-content-center">
        <Col md={7} style={{ height: "10em" }} className="col-7">
          <h1 className="fw-bolder">Welcome to Ganarpro!</h1>
          {!user?.subscriptions?.length && (
            <p>Dont have a subscription? Checkout the following options.</p>
          )}
        </Col>
      </Row>
      <Row>
        <Col className="col-7 justify-content-center mx-auto col-md-3">
          {user ? (
            ""
          ) : (
            <Link to="/signup" className="text-decoration-none text-dark">
              <Card className="">
                <Card.Img
                  variant="top"
                  src={trialImg}
                  style={{ width: "113%" }}
                />
                <Card.Body className="p-0">
                  <Card.Title className="fw-bolder">
                    Start with a free trial
                  </Card.Title>
                  <Card.Text>
                    Access Ganarpro Business Suite Cloud services.
                  </Card.Text>
                  <Button
                    variant="primary"
                    className="mt-auto align-self-start"
                  >
                    Start
                  </Button>
                </Card.Body>
              </Card>
            </Link>
          )}
        </Col>
      </Row>
      <LabelSummary />
      <Row className="my-3">
        <h2 className="text-start fw-bolder">Ganarpro services</h2>
      </Row>
      {uniqueFavorites.length > 0 ? (
        <Row className=" my-5 ">
          {uniqueFavorites?.map((card, index) => {
            if (index < 8) {
              return (
                <Col md={1} sm={1} className="mx-4 text-center">
                  <Link to={card.page_url} className="text-decoration-none">
                    <Row className="flex-column text-start">
                      {card.page_name === "Site Visit Generator" ? (
                        <>
                          <Col className="text-start">
                            <img
                              src={Pages["Site Visit Sheet"]?.imgSrc}
                              style={{ width: "50px", height: "50px" }}
                              alt="Site Visit Sheet"
                            />
                          </Col>
                          <Col>
                            <h5>Site Visit Sheet</h5>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col className="text-start">
                            <img
                              src={Pages[card.page_name]?.imgSrc}
                              style={{ width: "50px", height: "50px" }}
                              alt={card.page_name}
                            />
                          </Col>
                          <Col>
                            <h5>{Pages[card.page_name]?.name || card.page_name}</h5>
                          </Col>
                        </>
                      )}
                    </Row>
                  </Link>
                </Col>
              );
            } else {
              return null; // Don't render anything for indexes 8 and above
            }
          })}
        </Row>
      ) : (
        <Row className="justify-content-center flex">
          {cardData.length > 0 &&
            cardData.map((card, index) => {
              return (
                <Col key={card.id}>
                  <Link
                    to={card.linkTo}
                    className="text-decoration-none text-dark"
                  >
                    <Card className="h-100 border-0 p-0">
                      <Card.Body className="d-flex flex-column">
                        <div className="text-center mb-2">
                          <img
                            src={card.imgSrc}
                            alt={card.title}
                            style={{ height: "50px" }}
                            className="mb-2"
                          />
                          <h6 className="mb-1 fs-5">
                            {card.title}
                          </h6>
                        </div>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
              );
            })}
          {/* More Services Button */}
          <Col className="flex-shrink-0 me-3">
            <Link to="/pricing" className="text-decoration-none text-dark">
              <Card className="h-100 border-0 px-0">
                <Card.Body className="d-flex flex-column justify-content-between">
                  <FontAwesomeIcon icon={faArrowRight} className="text-primary" size="2xl"/>
                  <h6 className="mb-0 fs-5">
                    More Services
                  </h6>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        </Row>
      )}
      {pageList && (
        <>
          <Row className="my-3">
            <h2 className="text-start fw-bolder">Resources</h2>
          </Row>
          <Row>
            <Tabs defaultActiveKey="recent" id="resource-tabs">
              <Tab eventKey="recent" title="Recent">
                <Table className="text-start">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Last Viewed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pageList.map((resource, index) => (
                      <tr key={index}>
                        <td>
                          <Link
                            to={resource?.page_url}
                            className="text-decoration-none"
                          >
                            {/*<FontAwesomeIcon icon={faStar} />{" "}*/}
                            {resource?.page_name?.includes('Proposal') ? Pages[resource.page_name]?.name || resource.page_name : resource.page_name}
                          </Link>
                        </td>
                        <td>{resource.type}</td>
                        <td>{formatDate(resource.last_viewed)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Tab>
              <Tab eventKey="favorites" title="Favorites">
                <Table className="text-start">
                  <thead>
                    <tr>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uniqueFavorites?.map((resource, index) => (
                      <tr key={index}>
                        <td>
                          <Link
                            to={resource?.page_url}
                            className="text-decoration-none"
                          >
                            {/*<FontAwesomeIcon icon={faStar} />{" "}*/}
                            {Pages[resource.page_name]?.name || resource.page_name}
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {/* Implement favorite resources here */}
              </Tab>
            </Tabs>
          </Row>
        </>
      )}
      <Row></Row>
      {/*<Row className="justify-content-center">*/}
      {/*  <Col md={3} className="gy-3 my-md-5 my-xs-5 col-7">*/}
      {/*    <Link*/}
      {/*      to="/contact_outreach"*/}
      {/*      className="text-decoration-none text-dark"*/}
      {/*    >*/}
      {/*      <Card className="h-100">*/}
      {/*        <Card.Img*/}
      {/*          variant="top"*/}
      {/*          src={ContactOutreachIcon}*/}
      {/*          height="100px"*/}
      {/*        />*/}
      {/*        <Card.Body className="d-flex flex-column">*/}
      {/*          <Card.Title className="fw-bolder">Contact Outreach</Card.Title>*/}
      {/*          <Card.Text>*/}
      {/*            Tailored email marketing and contact management tool for North*/}
      {/*            American construction industry professionals*/}
      {/*          </Card.Text>*/}
      {/*          <Button variant="primary" className="mt-auto align-self-center">*/}
      {/*            Visit Contact Outreach*/}
      {/*          </Button>*/}
      {/*        </Card.Body>*/}
      {/*      </Card>*/}
      {/*    </Link>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <br />
      <br />
      <Row className="text-start">
        <h2 className="fw-bolder">Useful Links</h2>
      </Row>
      <Row
        className="text-start"
        style={{ fontSize: "16px", marginTop: "25px" }}
      >
        <Col>
          <Link
            to="https://learn.ganarpro.com"
            style={{ textDecoration: "none" }}
          >
            Technical Documentation{" "}
            <FontAwesomeIcon
              icon={faExternalLinkAlt}
              className="new-tab-icon"
              style={{ fontSize: "14px" }}
            />
          </Link>
        </Col>
        <Col>
          <Link
            to="https://www.ganarpro.com/support/getting-started/"
            style={{ textDecoration: "none" }}
          >
            Getting Started{" "}
            <FontAwesomeIcon
              icon={faExternalLinkAlt}
              className="new-tab-icon"
              style={{ fontSize: "14px" }}
            />
          </Link>
        </Col>
      </Row>
      <Row
        className="text-start"
        style={{ fontSize: "16px", marginTop: "15px", marginBottom: "30px" }}
      >
        <Col>
          <Link to="https://www.ganarpro.com/products/">Ganarpro Services</Link>
        </Col>
        <Col>
          <Link
            to="/pricing"
            onClick={(e) => {
              if (profile && profile?.subscriptions?.length > 0) {
                e.preventDefault();
                dispatch(getManageUserBilling(profile?.customer));
              }
            }}
          >
            Subscriptions
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default Home;
